import ImmunizationInfluenzaViewNew from "./ImmunizationInfluenzaViewNew";

export default ImmunizationInfluenzaViewNew;
